<div class="summary-order-concept-value">
    <span *ngIf="posologia">{{posologia}}</span>
    <br *ngIf="observaciones && posologia" />
    <span *ngIf="observaciones"><b>Comentarios:</b> {{observaciones}}</span>
</div>